module.exports = __webpack_public_path__ + "static/media/N.8e7adca2.png";